<template>
  <div
    v-if="market === MARKET_SLUG.LITHIUM || market === MARKET_SLUG.COBALT"
    class="relative mt-9 overflow-hidden rounded-xl border border-grey-600 p-7"
  >
    <div
      class="absolute left-0 top-0 aspect-video h-full w-[100%] object-bottom md:aspect-auto md:h-[100%]"
    >
      <ImageCommon
        fetch-priority="auto"
        :src="ICE_IMAGES.BACKGROUND_3"
        alt="Copper"
        classes="size-full min-w-full object-cover min-h-full"
      />
    </div>

    <!-- Overlay -->
    <div class="ice-overlay absolute left-0 top-0 h-full w-full" />

    <div class="relative flex h-full flex-col justify-between gap-3 text-white">
      <BMIceLogo class="w-[184px] h-[30px] md:w-[277px] md:h-[44px]" />
      <p
        class="line-clamp-5 text-h7 text-black md:text-h5 xl:max-w-96 2xl:line-clamp-none"
      >
        {{ item.text }}
      </p>
      <Button
        variant="clean"
        class="!m-0 !w-fit md:-mb-5 md:inline-flex"
        :link="item.link"
      >
        Find Out More
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '~/components/common/Button.vue'
import { MARKET_SLUG } from '~/src/constants/markets'
import ImageCommon from '~/src/components/common/images/ImageCommon.vue'
import { ICE_DATA, ICE_IMAGES } from '~/src/constants/home'
import BMIceLogo from '~/assets/icons/bm-ice.svg'

const props = defineProps({
  market: {
    type: String,
    required: true,
  },
})

const item = props.market === MARKET_SLUG.LITHIUM ? ICE_DATA[0] : ICE_DATA[1]
</script>

<style scoped lang="scss">
.ice-overlay {
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.9) 51%,
    rgba(0, 0, 0, 0)
  );
  @media only screen and (max-width: 768px) {
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.8) 31%,
      rgba(255, 255, 255, 0.2)
    );
  }
}
</style>
